export default __webpack_public_path__ + "static/media/mushroom-error_DE.63f3b09c.png";